module.exports = `function showUploadWidget() {
 cloudinary.openUploadWidget($config,
 (err, info) => {
   if (!err) {    
     console.log("Upload Widget event - ", info);
   }
  });
 }
`;
